import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { cn } from '@/shadcn-ui/utils';

interface TrendingFireProps extends SvgIconCommonProps {
  gradientKey?: string;
}

export default function TrendingFire({
  className,
  gradientKey = 'default',
}: TrendingFireProps) {
  const gradientId = `trending_fire_linear_${gradientKey}`;

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[16px] w-[16px]', className)}
    >
      <g id="ic-flame-sm">
        <path
          d="M7.69305 15C6.65319 15 5.74279 14.8126 4.96185 14.4378C4.18508 14.0629 3.57954 13.5382 3.14522 12.8635C2.71507 12.1888 2.5 11.4016 2.5 10.502C2.5 10.0231 2.53759 9.60866 2.61276 9.25881C2.68793 8.9048 2.7798 8.59244 2.88838 8.32173C3.00114 8.05102 3.1139 7.79697 3.22665 7.55957C3.33941 7.32218 3.43128 7.0827 3.50228 6.84114C3.57745 6.59542 3.61503 6.32471 3.61503 6.02901C3.61503 5.84575 3.60668 5.68333 3.58998 5.54172C3.57745 5.39595 3.57118 5.2606 3.57118 5.13565C3.57118 4.93574 3.62547 4.77956 3.73405 4.66711C3.84681 4.55466 3.99298 4.49844 4.17255 4.49844C4.36465 4.49844 4.55885 4.5505 4.75513 4.65462C4.9514 4.75457 5.13724 4.91492 5.31264 5.13565C5.48804 5.35222 5.64673 5.63751 5.78872 5.99152L5.54442 6.06024C5.59871 5.96029 5.63212 5.87074 5.64465 5.79161C5.65718 5.71248 5.66344 5.63127 5.66344 5.54797C5.66344 5.16481 5.59662 4.80247 5.46298 4.46095C5.32935 4.11944 5.14977 3.78626 4.92426 3.4614C4.69875 3.13238 4.45027 2.80336 4.17882 2.47434C4.09947 2.37855 4.03683 2.2786 3.99089 2.17448C3.94495 2.06619 3.92198 1.95791 3.92198 1.84962C3.92198 1.57474 4.03474 1.36442 4.26025 1.21865C4.48576 1.07288 4.78436 1 5.15604 1C5.71564 1 6.30866 1.06872 6.93508 1.20616C7.56568 1.33943 8.1921 1.54975 8.81435 1.83713C9.44077 2.12033 10.0338 2.48267 10.5934 2.92414C11.1572 3.36561 11.6562 3.88829 12.0905 4.49219C12.529 5.09609 12.8736 5.78536 13.1241 6.56002C13.3747 7.33467 13.5 8.20303 13.5 9.1651C13.5 10.0356 13.3622 10.8289 13.0866 11.5453C12.8109 12.2616 12.4163 12.8759 11.9026 13.3882C11.389 13.9047 10.7771 14.3024 10.0672 14.5814C9.35725 14.8605 8.56587 15 7.69305 15ZM7.85592 12.776C8.32365 12.776 8.72039 12.676 9.04613 12.4761C9.37187 12.2762 9.61826 12.0076 9.78531 11.6702C9.95653 11.3287 10.0421 10.9476 10.0421 10.527C10.0421 10.0939 9.96279 9.67113 9.8041 9.25881C9.64541 8.8465 9.41154 8.47375 9.10251 8.14056C8.79765 7.80738 8.42388 7.54499 7.98121 7.35341C7.92692 7.32842 7.8768 7.33051 7.83087 7.35966C7.7891 7.38881 7.77449 7.43671 7.78702 7.50335C7.84966 7.94482 7.86219 8.3613 7.8246 8.75279C7.79119 9.14012 7.69932 9.47122 7.54897 9.7461C7.47798 9.54618 7.39654 9.36918 7.30467 9.21508C7.21697 9.05682 7.10839 8.91522 6.97893 8.79027C6.92882 8.74862 6.88079 8.73821 6.83485 8.75904C6.79309 8.77986 6.77012 8.81526 6.76595 8.86524C6.74089 9.07348 6.68451 9.25673 6.59681 9.41499C6.50911 9.57326 6.41306 9.72944 6.30866 9.88353C6.20843 10.0335 6.12073 10.2021 6.04556 10.3896C5.97039 10.577 5.9328 10.8019 5.9328 11.0643C5.9328 11.5765 6.1082 11.9909 6.459 12.3075C6.81397 12.6198 7.27961 12.776 7.85592 12.776Z"
          fill={`url(#${gradientId})`}
        />
      </g>
      <defs>
        <linearGradient
          id={gradientId}
          x1="11.9187"
          y1="12.9875"
          x2="3.82614"
          y2="12.7149"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.flameDeepMagenta} />
          <stop offset="0.08" stopColor={colors.flamePinkMagenta} />
          <stop offset="0.17" stopColor={colors.flameDeepPink} />
          <stop offset="0.25" stopColor={colors.flamePinkRed} />
          <stop offset="0.34" stopColor={colors.flameRoseRed} />
          <stop offset="0.435" stopColor={colors.flameSunsetPink} />
          <stop offset="0.535" stopColor={colors.flameRedPinkOrange} />
          <stop offset="0.625" stopColor={colors.flameRedOrange} />
          <stop offset="0.715" stopColor={colors.flameSunsetOrange} />
          <stop offset="0.815" stopColor={colors.flameOrangeRed} />
          <stop offset="0.9" stopColor={colors.flameGoldenOrange} />
          <stop offset="1" stopColor={colors.flameSunburstOrange} />
        </linearGradient>
      </defs>
    </svg>
  );
}
